import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import Header from 'components/header';
import NotificationModal from 'components/shared/notification-modal';

import { defaultAccentColor } from 'data/accentColors';

import AppRoutes from 'AppRoutes';
import GlobalContext from 'GlobalContext';

import './index.scss';
import './App.scss';

function App() {
  const [showNotification, setShowNotification] = useState(false);
  const [notificationStatus, setNotificationStatus] = useState('');
  const [notificationText, setNotificationText] = useState(
    'example notification text'
  );

  const [currentTag, setCurrentTag] = useState({});
  const [currentProperty, setCurrentProperty] = useState({});
  const [currentAttribute, setCurrentAttribute] = useState({});
  const [showDetailModal, setShowDetailModal] = useState(false);

  const [jsViewTab, setJsViewTab] = useState('About');
  const [cssViewTab, setCssViewTab] = useState('About');
  const [htmlViewTab, setHtmlViewTab] = useState('About');
  const [templatesViewTab, setTemplatesViewTab] = useState('About');

  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem("techtutz-darkMode");
    return savedMode ? JSON.parse(savedMode) : true;
  });

  const [navExpanded, setNavExpanded] = useState(true);

  const [accentColor, setAccentColor] = useState(() => {
    const savedColor = localStorage.getItem("techtutz-accentColor");
    return savedColor || defaultAccentColor;
  });

  useEffect(() => {
    localStorage.setItem("techtutz-darkMode", JSON.stringify(darkMode));
    document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  useEffect(() => {
    localStorage.setItem("techtutz-accentColor", accentColor);
    document.documentElement.style.setProperty('--accent', accentColor);
    document.documentElement.style.setProperty('--accent-bg', `${accentColor}1a`);
    document.documentElement.style.setProperty('--accent-border', `${accentColor}80`);
  }, [accentColor]);

  return (
    <GlobalContext.Provider
      value={{
        darkMode,
        jsViewTab,
        currentTag,
        cssViewTab,
        htmlViewTab,
        navExpanded,
        accentColor,
        currentProperty,
        showDetailModal,
        notificationText,
        showNotification,
        templatesViewTab,
        currentAttribute,
        notificationStatus,
        setDarkMode,
        setNavExpanded,
        setAccentColor,
        setJsViewTab,
        setCssViewTab,
        setCurrentTag,
        setHtmlViewTab,
        setCurrentProperty,
        setShowDetailModal,
        setNotificationText,
        setShowNotification,
        setCurrentAttribute,
        setTemplatesViewTab,
        setNotificationStatus,
      }}
    >
      <section
        className='app-shell'
        style={{
          width: '100vw',
          height: '100vh',
          backgroundColor: darkMode ? '#222' : '#fff',
        }}
      >
      <BrowserRouter>
        <Header />
        {showNotification && (
          <NotificationModal notificationText={notificationText} />
        )}
        <section
          className='app-content'
          style={{
            backgroundColor: darkMode ? '#222' : '#fff',
          }}
        >
          <AppRoutes />
        </section>
      </BrowserRouter>
      </section>
    </GlobalContext.Provider>
  );
}

export default App;
